import repository from "@/api/Main/SystemSettings/customerAccessSettings";
import Swal from "sweetalert2";

export default {
  state: {
    customer_access_assignments: [],
    customer_access_users: [],
    customer_access_mother_customers: [],
    customer_access_individual_customers: [],
    customer_access_loaded: false,
  },
  getters: {
    GET_CUSTOMER_ACCESS_ASSIGNMENTS: (state) => state.customer_access_assignments,
    GET_CUSTOMER_ACCESS_USERS: (state) => state.customer_access_users,
    GET_CUSTOMER_ACCESS_MOTHER_CUSTOMERS: (state) => state.customer_access_mother_customers,
    GET_CUSTOMER_ACCESS_INDIVIDUAL_CUSTOMERS: (state) => state.customer_access_individual_customers,
    GET_CUSTOMER_ACCESS_LOADED: (state) => state.customer_access_loaded,
  },
  actions: {
    loadCustomerAccessSettings({ commit, state }) {
      if (state.customer_access_loaded) {
        return Promise.resolve();
      }

      return repository
        .getCustomerAccessSettings()
        .then((response) => {
          commit("CUSTOMER_ACCESS_LOAD", response.data);
        })
        .catch(() => {
          Swal.fire({ title: "ERROR", icon: "error" });
        });
    },
    refreshCustomerAccessSettings({ commit }) {
      return repository
        .getCustomerAccessSettings()
        .then((response) => {
          commit("CUSTOMER_ACCESS_LOAD", response.data);
        })
        .catch(() => {
          Swal.fire({ title: "ERROR", icon: "error" });
        });
    },
    resolveCustomerAccessPaste(_, payload) {
      return repository.resolveCustomerAccessPaste(payload);
    },
    storeCustomerAccess({ dispatch }, payload) {
      return repository
        .storeCustomerAccess(payload)
        .then(() => dispatch("refreshCustomerAccessSettings"))
        .catch((error) => {
          const message = error?.response?.data?.message || "Failed to add customer access rule.";
          Swal.fire({ title: message, icon: "error" });
          throw error;
        });
    },
    updateCustomerAccess({ dispatch }, { id, payload }) {
      return repository
        .updateCustomerAccess(id, payload)
        .then(() => dispatch("refreshCustomerAccessSettings"))
        .catch(() => {
          Swal.fire({ title: "ERROR", icon: "error" });
        });
    },
    deleteCustomerAccess({ dispatch }, id) {
      return repository
        .deleteCustomerAccess(id)
        .then(() => dispatch("refreshCustomerAccessSettings"))
        .catch(() => {
          Swal.fire({ title: "ERROR", icon: "error" });
        });
    },
  },
  mutations: {
    CUSTOMER_ACCESS_LOAD(state, payload) {
      state.customer_access_assignments = payload.assignments || [];
      state.customer_access_users = payload.users || [];
      state.customer_access_mother_customers = payload.mother_customers || [];
      state.customer_access_individual_customers = payload.individual_customers || [];
      state.customer_access_loaded = true;
    },
  },
};
